export interface Card {
  _id: string
  name: string
  category: string
  image: string
  rate: number
  type: TradeType
  isDisabled: boolean
  createdAt: string
}

export interface IGiftCard {
  cards: Card[]
  image: string
  name: string
  isDisabled: boolean
}

export enum TradeType {
  buy = 'buy',
  sell = 'sell',
}

export type InitialFormValues = {
  type: TradeType
  card: string
  amount: number
  extrainfo: string
  file: File | null
  acceptTerms: boolean
}

export interface TradeGiftCard {
  cards: Card[]
  name: string
  isDisabled: boolean
  isTradeModalOpen: boolean
  setIsTradeModalOpen: React.Dispatch<React.SetStateAction<boolean>>
  initialCardId?: string
  initialRate?: number
  hideButton?: boolean
}
